import React from "react";
import Index from "../Index";

function AuthFooter() {
  return (
    <footer className="new-auth-footer">
      <div className="new-auth-footer-container">
        
        {/* Description Column */}
        <div className="footer-col-brand">
          <p className="new-auth-footer-desc">
            TRAC ERP is a cloud-based ERP solution tailored for the manufacturing industry, helping businesses streamline operations, improve accuracy, and grow with confidence.
          </p>
        </div>

        <div className="footer-main-divider"></div>

        {/* Feature Icons with dividers between each */}
        <div className="footer-col-features">
          <div className="footer-feature-item">
            <div className="footer-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
              </svg>
            </div>
            <span>Cloud-Based<br />& Secure</span>
          </div>

          <div className="footer-feat-divider"></div>

          <div className="footer-feature-item">
            <div className="footer-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <span>Real-time<br />Insights</span>
          </div>

          <div className="footer-feat-divider"></div>

          <div className="footer-feature-item">
            <div className="footer-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <span>Multi-user<br />Support</span>
          </div>

          <div className="footer-feat-divider"></div>

          <div className="footer-feature-item">
            <div className="footer-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <polyline points="9 12 11 14 15 10" />
              </svg>
            </div>
            <span>GST<br />Compliant</span>
          </div>

          <div className="footer-feat-divider"></div>

          <div className="footer-feature-item">
            <div className="footer-icon-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 3 21 3 21 9" />
                <polyline points="9 21 3 21 3 15" />
                <line x1="21" y1="3" x2="14" y2="10" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            </div>
            <span>Scalable<br />Anytime</span>
          </div>
        </div>

        <div className="footer-main-divider"></div>

        {/* Contacts Column */}
        <div className="footer-col-contact">
          <ul className="footer-contact-list">
            <li>
              <a href="tel:+917303044483" className="footer-contact-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span>+91 73030 44483</span>
              </a>
            </li>
            <li>
              <a href="mailto:tracerpcloud@gmail.com" className="footer-contact-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>tracerpcloud@gmail.com</span>
              </a>
            </li>
            <li>
              <a href="https://trtrac.com" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
                <span>https://trtrac.com</span>
              </a>
            </li>
          </ul>
        </div>

      </div>

      <div className="new-auth-footer-bottom">
        <span>© 2025 Trac ERP. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default AuthFooter;
